<div class="m-4">
  <form [formGroup]="inputForm">
    <div class="row">
      <div class="col-4">
        <h4>Source</h4>
          <div class="form-check-inline" *ngFor="let x of ipType | keyvalue">
              <label class="form-check-label">
                <input
                  type="radio"
                  class="form-check-input"
                  value="{{x.value}}"
                  formControlName="ipType">{{x.key}}
              </label>
          </div>
        <div>
          <select class="form-control" formControlName="sourceDevice">
            <option>Select Source POP</option>
            <option *ngFor="let device of devices; let first = first" value="{{device.city}}" [selected]="first">
              {{device.region}} ({{device.city}})
            </option>
          </select>
        </div>
      </div>
      <div class="col-4">
        <h4>Action</h4>
        <div class="form-check" *ngFor="let x of actions | keyvalue">
          <label class="form-check-label">
            <input type="radio"
                   class="form-check-input"
                   formControlName="action"
                   value="{{x.value}}">{{x.value}}
          </label>
        </div>
      </div>
      <div class="col-4">
        <h4>Destination</h4>
        <div *ngIf="inputForm.value.action != actions.c_route; else showRouteInput">
          <div class="form-check">
            <label class="form-check-label">
              <input
                type="radio"
                class="form-check-input"
                formControlName="destination"
                (click)="destinationType=destinations.your_ip"
                value="{{destinations.your_ip}}">Your IP - {{myIpAddress.my_ip}}
            </label>
          </div>
          <div class="form-check">
            <label class="form-check-label">
              <input
                type="radio"
                class="form-check-input"
                formControlName="destination"
                (click)="destinationType=destinations.ip_address"
                value="{{destinations.ip_address}}">IP Address
            </label>
          </div>
          <div *ngIf="inputForm.value.destination == destinations.ip_address" class="mt-2 mb-2">
            <input
              type="text"
              class="form-control text-sm-left"
              formControlName="target"
              placeholder="IP address or FQDN to check"
              required="true"
              >
          </div>
<!--          <div class="form-check">-->
<!--            <label class="form-check-label">-->
<!--              <input-->
<!--                type="radio"-->
<!--                class="form-check-input"-->
<!--                formControlName="destination"-->
<!--                (click)="destinationType=destinations.gcx_sites"-->
<!--                value="{{destinations.gcx_sites}}">GCX Site-->
<!--            </label>-->
<!--          </div>-->
<!--          <div *ngIf="inputForm.value.destination == destinations.gcx_sites" class="mt-2">-->
<!--            <select class="form-control" formControlName="destinationDevice">-->
<!--              <option disabled>Select Destination POP</option>-->
<!--              <option *ngFor="let device of devices; let first=first" value="{{device.city}}">-->
<!--                {{device.region}} ({{device.city}})-->
<!--              </option>-->
<!--            </select>-->
<!--          </div>-->
        </div>
        <ng-template #showRouteInput>
          <input
            class="form-control text-sm-left"
            placeholder="IP address"
            formControlName="target"
            type="text">
        </ng-template>
      </div>
      <div class="row m-4">
        <button class="btn btn-primary" type="submit" (click)="submitRequest()">Submit</button>
      </div>
    </div>
  </form>
  <hr>
  <div class="d-flex justify-content-center" *ngIf="showSpinner">
    <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div class="row m-4" *ngIf="isError">
    <b>{{errorMsg}}</b>
  </div>
  <app-results *ngIf="showResults" [inputForm]="inputForm" [results]="results"></app-results>
</div>
